<template>
    <div class="base-alert">
        <h3 class="base-alert-header"><slot name="header"/></h3>
        <slot/>
    </div>
</template>

<script>
    export default {
        name: "BaseAlert"
    };
</script>

<style scoped lang="scss">
    @import "~@/assets/scss/_variables.scss";
    .base-alert {
        margin-top: 1rem;
        border-left: thick solid $primary;
        padding: 1rem;
        background-color: lighten($primary, 40);
        .base-alert-header {
            color: $primary
        }

        ::v-deep a {
            color: $primary
        }
    }
</style>